/* DON'T EDIT THIS FILE: edit original and run build again */ import { MaybeArray, toArray } from "../../framework/core/maybe-array.ts";
import { typeCheckerCheckArray } from "./type-checker-array-checker.ts";
import { typeCheckerSchemaFailResult } from "./type-checker-errors.ts";
import { typeCheckerCheckObject } from "./type-checker-object-checker.ts";
import { typeCheckerCheckPrimitive } from "./type-checker-primitive-checker.ts";
import { typeCheckerCheckRecord } from "./type-checker-record-checker.ts";
import {
  TypeCheckerResult,
  TypeCheckerSchema,
  TypeCheckerSchemaType,
  TypeCheckerStatus,
  ValidatedTypeCheckerSchema,
} from "./type-checker-types.ts";

const check = (
  checker: MaybeArray<TypeCheckerSchema>,
  value: unknown,
  path: string
): TypeCheckerResult => {
  const orChecker = toArray(checker);
  let i = -1;
  let result: TypeCheckerResult = typeCheckerSchemaFailResult(value, path);
  while (++i < orChecker.length && result.status !== TypeCheckerStatus.ok) {
    const orSchema = orChecker[i];
    if (orSchema.type === TypeCheckerSchemaType.primitive) {
      result = typeCheckerCheckPrimitive(orSchema, value, path);
    } else if (orSchema.type === TypeCheckerSchemaType.array) {
      result = typeCheckerCheckArray(orSchema, value, path, check);
    } else if (orSchema.type === TypeCheckerSchemaType.object) {
      result = typeCheckerCheckObject(orSchema, value, path, check);
    } else if (orSchema.type === TypeCheckerSchemaType.record) {
      result = typeCheckerCheckRecord(orSchema, value, path, check);
    } else {
      console.error(
        "typeCheckValueError: function called with invalid checker, will attempt to continue."
      );
    }
  }
  return result;
};

export const validatedTypeChecker = <T = never /* must be provided */>(
  checker: TypeCheckerSchema<T>
) => checker as ValidatedTypeCheckerSchema<T>;

export const typeCheckValue = <T>(
  value: unknown,
  checker: ValidatedTypeCheckerSchema<T>
): TypeCheckerResult<T> =>
  // given validatedTypeChecker could infer the checker's type correctly,
  // we can trust the check fn results in a valid instance for the type
  // (unless there are bugs :)
  check(checker as TypeCheckerSchema, value, "") as TypeCheckerResult<T>;
